module.exports = __webpack_public_path__ + "img/giganaut.93667c67.png";